import instance from "../api/axios";
import { ApiRequest } from "../types/requests/ApiRequest";
import { ApiResponse } from "../types/responses/ApiResponse";
import { UpdateCustomFieldsValuesRequest } from "../types/requests/UpdateCustomFieldsValuesRequest";
import { UpdateCustomFieldsValuesResponse } from "../types/responses/UpdateCustomFieldsValuesResponse";

export const accountService = {
  updateCustomFieldsValues: async (request: ApiRequest<UpdateCustomFieldsValuesRequest>): Promise<ApiResponse<UpdateCustomFieldsValuesResponse>> => await instance.post<ApiRequest<UpdateCustomFieldsValuesRequest>, ApiResponse<UpdateCustomFieldsValuesResponse>>('/p1/Account/update_custom_fields_values', request),
}